import React from 'react'

const CertificateBanner = () => {
  return (
    <div className='certificate-banner'>
      <div className='certificate-banner-content'>
        <h1>VERIFY YOUR  CERTIFICATION <br />INSTANTLY AND SECURELY</h1>
        <p>VERIFY ANY ISO CERTIFICATE ISSUSED BY US TO CONFIRM ITS AUTHENTICITY AND <br />VALIDITY IN REAL TIME.</p>
        <button className='btn btn-outline-light rounded-pill pX-4 mt-3'>Get Started</button>
      </div>
    </div>
  )
}

export default CertificateBanner
